import React, { useContext } from 'react';
import { Card, CardBody, Container } from 'reactstrap';
import Header from '../../../component/Header';
import { AppContext } from "../../../context/app-context";
import { getAge } from '../../../helper';

const Measure = () => {
    const [state, dispatch] = useContext(AppContext);
    const data = state.riskAssessment.preRiskAssessment;
    const risk = state.riskAssessment;
   
    const QueCard = (obj) => {
        let score, lable, dec;
        if(obj.que.questionerLabel === 'family_diabieties_history'){
            
            score = risk.diabetes === 'yes' ? 1 : 0;
            lable = 'Family History';
            dec= 'A family history of diabetes could contribute to your risk for type 2 diabetes'
        }
        else if(obj.que.questionerLabel === 'high_blood_pressure'){
            score = risk.bloodPressure === 'yes' ? 1 : 0;
            lable = 'Blood pressure';
            dec= 'Having high blood pressure contributes to your overall risk for type 2 diabetes.'
        }
        else if(obj.que.questionerLabel === 'physically_active'){
            score = risk.physicallyActive === 'yes' ? 0 : 1;
            lable = 'Physically active';
            dec= 'Being inactive can increase your risk for type 2 diabetes.'
        }
        else if(obj.que.questionerLabel === 'gestational_diabetes'){
            score = risk.gestationalDiabetes === 'yes' ? 1 : 0;
            lable = 'Gestational diabetes';
            dec= 'History of gestational diabetes mellitus ( GDM ) increases the lifetime risk of developing type 2 diabetes'
        }
        
        return (
            <Card className={`measure-card mb-3 ${score > 0 ? 'measure-card-high': 'measure-card-low'}`}>
                <CardBody>
                    <div className="d-flex align-items-center">
                        <div className='point mb-2'>{score === 0 ? 0 : '+'+score} point</div>
                        <div className="ms-auto m-title mb-2">
                            {lable}
                        </div>
                    </div>
                    <p className='mb-0'>{dec}</p>
                </CardBody>
            </Card>
        )
    }

    
    let scoreCount = 0;
    if(risk.bmi.bmi >= 40)
        scoreCount += 3
    else if(risk.bmi.bmi < 40 && risk.bmi.bmi >= 30)
        scoreCount += 2
    else if(risk.bmi.bmi < 30 && risk.bmi.bmi >= 25)
        scoreCount += 1

    let ageScoreCount = 0;
    const userAge = getAge(state.user.dob);
    if(userAge >= 60)
        ageScoreCount += 3
    else if(userAge < 60 && userAge >= 50)
        ageScoreCount += 2
    else if(userAge < 50 && userAge >= 40)
        ageScoreCount += 1

    return (
        <>
            <Header title="How we measure?" />
            <Container className='mb-4'>
                <div className="text-center mt-4 mb-4">
                    <div className={`number-circle ${data.assessmentScore < 5 ? 'score-color-low' : 'score-color-high'}`}>{data.assessmentScore}</div>
                    <h5 className='risk-score-lable'>RISK SCORE</h5>
                    <p className="mb-0">We have assigned points to your responses to better understand what your diabetic risk is. This is adapted from the American Diabetic association.</p>
                </div>
                <h2 className='factors-score mb-3'>Factors for the score</h2>
                <Card className={`measure-card mb-3 ${ageScoreCount > 0 ? 'measure-card-high': 'measure-card-low'}`}>
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className='point mb-2'>{ageScoreCount === 0 ? 0 : '+'+ageScoreCount} point</div>
                            <div className="ms-auto m-title mb-2">
                            Age
                            </div>
                        </div>
                        <p className='mb-0'>The older you are, the higher your risk is for type 2 diabetes</p>
                    </CardBody>
                </Card>
                { state.user.gender.toLowerCase() === 'male' &&
                    <Card className={`measure-card mb-3 measure-card-high`}>
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className='point mb-2'>+1 point</div>
                                <div className="ms-auto m-title mb-2">
                                Gender
                                </div>
                            </div>
                            <p className='mb-0'>Men are more likely than women to have undiagnosed diabetes.</p>
                        </CardBody>
                    </Card>
                }
                {data.questionerResponse.map(obj => <QueCard que={obj} key={obj.questionerLabel} />)}
                <Card className={`measure-card mb-3 ${scoreCount > 0 ? 'measure-card-high': 'measure-card-low'}`}>
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className='point mb-2'>{scoreCount === 0 ? 0 : '+'+scoreCount} point</div>
                            <div className="ms-auto m-title mb-2">
                            BMI
                            </div>
                        </div>
                        <p className='mb-0'>People with higher BMIs are at a higher risk for type 2 diabetes.</p>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
}

export default Measure;